import create from 'zustand';
import securitiesAPI from 'lib/api/securities';
import noticeError from 'utils/logger';
import { AuthModalStatus } from 'features/securities/AuthModal/types';

interface State {
  status: AuthModalStatus | null;
}

interface Action {
  resetStore: () => void;
  loadAccountStatus: () => Promise<void>;
}

const initialState: State = {
  status: null,
};

const useOpeningAccountStore = create<State & Action>((set) => ({
  ...initialState,
  resetStore: () => set({ status: null }),
  loadAccountStatus: async () => {
    try {
      const res = await securitiesAPI.getOAStatus();
      const { data, error } = res?.data ?? {};
      if (!data || error) {
        throw new Error('Attempt to get oa status failed');
      }

      set({ status: data.status });
    } catch (error) {
      noticeError(error, {
        event: 'useOpeningAccountStore@loadAccountStatus',
        errCause: error?.cause,
      });
    }
  },
}));

export default useOpeningAccountStore;
